import React  from 'react';
import { Outlet } from 'react-router-dom';

const OnBoarding = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default OnBoarding;